// src/components/DeleteConversationsModal.tsx
import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import "./DeletePopup.css";
import { useClearAllConversations } from "../../../../store/Apis/ConversationApi";
import {
  handleNewConversationRequest,
  setChat1Data,
  setChat2Data,
  setChat3Data,
  setChat4Data,
  setChat5Data,
  setChat6Data,
  setFileError,
} from "../../../../store/one-query/chatsSlice";
import { useNavigate, useParams } from "react-router-dom";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import { ErrorIcon } from "../../../../Custom-imeges/ErrorIcon";

interface DeleteModalProps {
  show: boolean;
  handleClose: () => void;
  name: string;
  message?: string;
  method?: () => void;
  page?: string;
  deleteStep?: boolean;
  deleteWorkflow?:boolean
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  show,
  handleClose,
  name,
  message,
  method,
  page,
  deleteStep,
  deleteWorkflow
}) => {
  const conversationsHistory = useAppSelector(
    (state) => state.Conversations.conversations
  );
  const [confirmDelete, setConfirmDelete] = useState<string>("");
  const dispatch = useAppDispatch();
  const clearAllConversations = useClearAllConversations();
  const navigate = useNavigate();
  const [flagDeleteAllConversation, setFlagDeleteAllConversation] =
    useState<boolean>(false);
  const [flagDeleteSpecficConversation, setFlagDeleteSpecficConversation] =
    useState<boolean>(false);
  const isNewConversation = useAppSelector((s) => s.ChatsState.newConversation);
  const { id } = useParams<{ id: string }>();
  const navigateToMainPage = useNavigateToMainPage();
  const [showMssError,setShowMsgError] = useState(false);

  const handleDelete = () => {
    if (name === "Clear all conversations") {
      if (confirmDelete.trim().toLowerCase() === "delete") {
        clearAllConversations();
        if (!isNewConversation) {
          dispatch(setChat1Data({ id: "", version: "", name: "" }));
          dispatch(setChat2Data({ id: "", version: "", name: "" }));
          dispatch(setChat3Data({ id: "", version: "", name: "" }));
          dispatch(setChat4Data({ id: "", version: "", name: "" }));
          dispatch(setChat5Data({ id: "", version: "", name: "" }));
          dispatch(setChat6Data({ id: "", version: "", name: "" }));
          dispatch(handleNewConversationRequest());
        }
        handleClose();
        setConfirmDelete("");
        setFlagDeleteAllConversation(true);
        setShowMsgError(false);
      } else {
        setShowMsgError(true)
      }
    } else {
      if (method) {
        method();
      }
      setFlagDeleteSpecficConversation(true);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      handleDelete();
    }
  };

  useEffect(() => {
    setConfirmDelete("");
  }, [handleClose]);

  useEffect(() => {
    if (
      (id && flagDeleteAllConversation && conversationsHistory.length === 0) ||
      (id && flagDeleteSpecficConversation)
    )
    navigateToMainPage();
    setFlagDeleteSpecficConversation(false);
  }, [
    id,
    conversationsHistory,
    flagDeleteSpecficConversation,
    flagDeleteAllConversation,
  ]);

  const handleClosePopup = ()=> {
    handleClose();
    setShowMsgError(false);
  }

  return (
    <Modal className="DeleteModal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="clearConPopupHeader border-0">
        <Modal.Title>{name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={`DeleteModalBody border-0 rounded-bottom-4 px-0`}>
        {(conversationsHistory.length === 0&&!deleteStep &&!deleteWorkflow) ? (
          <div className="d-flex flex-column align-items-center p-4">
              <p className="emptyHistoryText">
                History is already empty. There's nothing to delete.
              </p>
          </div>
        ) : (
          <div className="deleteRequirements d-flex flex-column align-items-center justify-content-center">
            <div className="mb-1 w-100 d-flex flex-column px-4">
              <p className="warningDeleteText text-start">{message}</p>
              {name === "Clear all conversations" && (
                <Form.Control
                  className="confirmDeleteInput"
                  placeholder="Type 'delete' in the box to confirm."
                  value={confirmDelete}
                  onChange={(e) => setConfirmDelete(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              )}
              {showMssError && 
              <div className="match-error-msg">
                <ErrorIcon/>
                <span>Incorrect word.</span>
                </div>}
            </div>
            <div className="line popup"></div>
            <div className="d-flex pb-2 pe-3 buttons w-100 justify-content-end">
              <button className="cancelDeleteBtn mx-2" onClick={handleClosePopup}>
                Cancel
              </button>
             {name==="Delete workflow"||name==="Delete step"?
             (
              <button
                className="confirmDeleteBtn deleteWorkflow mx-2 py-3"
                onClick={method}
              >
               {deleteStep?"Delete step" :"Delete"}
              </button>
             ):(<button
                className="confirmDeleteBtn mx-2 py-3"
                onClick={handleDelete}
              >
                {name === "Delete conversation" ? "Delete" : "Confirm"}
              </button>)}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
